import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useEffect } from 'react';

import useHandleError from '@/hooks/useHandleError';
import type { components } from '@/types/openapi';

type AssetTagDTO = components['schemas']['AssetTag'];
/**
 * Hook to fetch asset tags for the currently selected organization
 */
const useFetchOrganizationAssetTags = (id: number) => {
  const handleError = useHandleError();

  const { data, error, isError, ...queryResult } = useQuery<
    AssetTagDTO[],
    AxiosError
  >({
    queryKey: [`organizations/${id}/asset_tags`],
    enabled: !!id,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });

  useEffect(() => {
    if (isError) {
      handleError(
        error as AxiosError,
        'Failed to fetch organization asset tags'
      );
    }
  }, [isError, error, handleError]);

  return {
    data,
    error,
    isError,
    ...queryResult
  };
};

export default useFetchOrganizationAssetTags;
